import { useEffect, useState, ChangeEvent } from 'react'
import { Button, Col, Form, FormControl, FormSelect, Row } from 'react-bootstrap'
import { FilePersonFill } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { t } from '../locale'
import { getAbbrevSalutation, getAddressType, getShippingSuplement } from '../service/stammdaten'
import { ChangeEvt, CompanyForm, PersonForm } from '../types/stammdaten.type'
import { useOutsideClick } from '../hooks/useOutsideClick'
import KDayPicker from '../components/KDayPicker'

type UnterhnemenProps = {
  form: CompanyForm | PersonForm
  options: any
  handleChangeLocal: (e: ChangeEvt) => void
  handleDateInputChange: (e: ChangeEvent<HTMLInputElement>) => void
  history: (path: string, label: string, options?: { value: any; label: string }[]) => void
  handleRemoveAddress: (idx: number) => void
  handleDateChange: (id: string, date: Date | null) => void
  handleToggleDifferent: (idx: number, checked: boolean) => Promise<void>
  handleAddAddress: () => void
  required: any
}
export default function StammdatenAddress({
  form,
  options,
  handleChangeLocal,
  handleDateInputChange,
  history,
  handleRemoveAddress,
  handleDateChange,
  handleToggleDifferent,
  handleAddAddress,
  required,
}: UnterhnemenProps) {
  const [addressType, setAddressType] = useState<any[]>([])
  const [shippingSuplement, setShippingSuplement] = useState<any[]>([])
  const [abbrevSalutation, setAbbrevSalutation] = useState<any[]>([])

  const [datePickerValidSince, setDatePickerValidSince] = useState<number | null>(null)
  const [datePickerValidTo, setDatePickerValidTo] = useState<number | null>(null)

  useEffect(() => {
    fetchAddressType()
    fetchShippingSuplement()
    fetchAbbrevSalution()
  }, [])

  useOutsideClick(() => {
    setDatePickerValidSince(null)
    setDatePickerValidTo(null)
  }, 'address-date-area')

  const fetchAddressType = async () => {
    try {
      const options = await getAddressType()
      setAddressType(options)
    } catch (err) {
      console.error('Fetch error register entry: ', err)
    }
  }

  const fetchShippingSuplement = async () => {
    try {
      const options = await getShippingSuplement()
      setShippingSuplement(options)
    } catch (err) {
      console.error('Fetch error register entry: ', err)
    }
  }

  const fetchAbbrevSalution = async () => {
    try {
      const options = await getAbbrevSalutation()
      setAbbrevSalutation(options)
    } catch (err) {
      console.error('Fetch error register entry: ', err)
    }
  }

  return (
    <>
      <div id='adress-data' className='mb-4'>
        {form.address.map((addr, idx) => (
          <div key={idx} className='mb-4'>
            {/* "Adresse" */}
            <div className='bg-gray-200 p-2 d-flex align-items-center justify-content-between mb-3'>
              <span className='d-flex align-items-center'>
                <FilePersonFill />
                &nbsp;{t('Adresse')} {form.address.length > 1 ? `#${idx + 1}` : ''}
              </span>
              <Link
                to='#'
                className='text-danger small'
                onClick={e => {
                  e.preventDefault()
                  handleRemoveAddress(idx)
                }}
              >
                {t('remove')}
              </Link>
            </div>

            {/* Gültig: From / Until */}
            <Row className='mt-2'>
              <Col className='col-sm-2'>
                <label
                  className={`form-control-label ${required.address.valid_since ? 'required' : ''}`}
                >
                  {t('gültig')}
                </label>
              </Col>

              <Col className='col-sm-6'>
                <div className='d-flex'>
                  {/* FROM */}
                  <div className='me-4 position-relative address-date-area'>
                    <div className='d-flex align-items-center mb-1'>
                      <span>{t('von')}</span>
                      <button
                        type='button'
                        className='btn btn-link btn-sm p-0'
                        onClick={() =>
                          history(`stammdaten.address.${idx}.valid_since`, t('gültig'))
                        }
                      >
                        <i className='fa fa-history text-dark' />
                      </button>
                    </div>

                    <Form.Control
                      name='von'
                      id={`address.${idx}.valid_since`}
                      type='text'
                      className='form-control'
                      value={addr.valid_since || ''}
                      onClick={() =>
                        setDatePickerValidSince(datePickerValidSince === idx ? null : idx)
                      }
                      onChange={handleDateInputChange}
                      placeholder='DD.MM.YYYY'
                      inputMode='numeric'
                      maxLength={10}
                      required={required.address.valid_since}
                    />
                    <KDayPicker
                      open={datePickerValidSince === idx}
                      value={addr.valid_since}
                      required={required.address.valid_since}
                      onSelect={d => {
                        handleDateChange(`address.${idx}.valid_since`, d)
                        setDatePickerValidSince(null)
                      }}
                    />
                  </div>
                  {/* UNTIL */}
                  <div className='position-relative address-date-area'>
                    <div className='d-flex align-items-center mb-1'>
                      <span>{t('bis')}</span>
                      <button
                        type='button'
                        className='btn btn-link btn-sm p-0'
                        onClick={() => history(`stammdaten.address.${idx}.valid_to`, t('gültig'))}
                      >
                        <i className='fa fa-history text-dark' />
                      </button>
                    </div>

                    <Form.Control
                      id={`address.${idx}.valid_to`}
                      name='bis'
                      type='text'
                      className='w-100 form-control'
                      value={addr.valid_to || ''}
                      onClick={() => setDatePickerValidTo(datePickerValidTo === idx ? null : idx)}
                      onChange={handleDateInputChange}
                      placeholder='DD.MM.YYYY'
                      inputMode='numeric'
                      maxLength={10}
                      required={required.address.valid_to}
                    />
                    <KDayPicker
                      open={datePickerValidTo === idx}
                      value={addr.valid_to}
                      required={required.address.valid_to}
                      onSelect={d => {
                        handleDateChange(`address.${idx}.valid_to`, d)
                        setDatePickerValidTo(null)
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            {/* Adresszusatz */}
            <Row className='mt-4'>
              <Col className='col-sm-2'>
                <label
                  className={`form-control-label ${required.address.address_suffix ? 'required' : ''}`}
                >
                  {t('adresszusatz')}
                </label>
              </Col>
              <Col>
                <FormControl
                  name={t('adresszusatz')}
                  id={`address.${idx}.address_suffix`}
                  type='text'
                  className='w-25 d-inline'
                  value={addr.address_suffix}
                  onChange={handleChangeLocal}
                  required={required.address.address_suffix}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.address.${idx}.address_suffix`, t('adresszusatz'))
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </Col>
            </Row>

            {/* Adressart */}
            <Row className='mt-4'>
              <Col className='col-sm-2'>
                <label className={`form-control-label required`}>{t('adressart')}</label>
              </Col>
              <Col>
                <FormSelect
                  name={t('adressart')}
                  className='w-25 d-inline'
                  id={`address.${idx}.type`}
                  value={addr.type || ''}
                  onChange={handleChangeLocal}
                  required={true}
                >
                  <option value=''>--</option>
                  {addressType.map((opt, i) => (
                    <option key={i} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </FormSelect>
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.address.${idx}.type`, t('adressart'), addressType)
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </Col>
            </Row>

            {addr.type === 'street' && (
              <Row className='mt-3'>
                <Col className='col-sm-2'>
                  <label className={`form-control-label required`}>{t('street')}</label>
                </Col>
                <Col>
                  <FormControl
                    name={t('street')}
                    className='w-25 d-inline'
                    type='text'
                    id={`address.${idx}.street`}
                    value={addr.street || ''}
                    onChange={handleChangeLocal}
                    required={true}
                  />
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() => history(`stammdaten.address.${idx}.street`, t('street'))}
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </Col>
              </Row>
            )}

            {addr.type === 'post_office_box' && (
              <Row className='mt-3'>
                <Col className='col-sm-2'>
                  <label className='form-control-label required'>{t('postfachadresse')}</label>
                </Col>
                <Col>
                  <FormControl
                    name={t('postfachadresse')}
                    className='w-25 d-inline'
                    type='text'
                    id={`address.${idx}.post_office_box`}
                    value={addr.post_office_box || ''}
                    onChange={handleChangeLocal}
                    required={true}
                  />
                  <button
                    type='button'
                    className='btn btn-link btn-sm'
                    onClick={() =>
                      history(`stammdaten.address.${idx}.post_office_box`, t('postfachadresse'))
                    }
                  >
                    <i className='fa fa-history text-dark' aria-hidden='true'></i>
                  </button>
                </Col>
              </Row>
            )}

            {/* POSTCODE */}
            <Row className='mt-4'>
              <Col className='col-sm-2'>
                <label className={`form-control-label required`}>{t('postcode')}</label>
              </Col>
              <Col>
                <FormControl
                  name={t('postcode')}
                  className='w-25 d-inline'
                  type='text'
                  id={`address.${idx}.zip_code`}
                  value={addr.zip_code}
                  onChange={handleChangeLocal}
                  required={true}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() => history(`stammdaten.address.${idx}.zip_code`, t('postcode'))}
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </Col>
            </Row>

            {/* Place */}
            <Row className='mt-4'>
              <Col className='col-sm-2'>
                <label className={`form-control-label required`}>{t('place')}</label>
              </Col>
              <Col>
                <FormControl
                  name={t('place')}
                  className='w-25 d-inline'
                  type='text'
                  id={`address.${idx}.city`}
                  value={addr.city}
                  onChange={handleChangeLocal}
                  required={true}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() => history(`stammdaten.address.${idx}.city`, t('place'))}
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </Col>
            </Row>

            {/* Country */}
            <Row className='mt-4'>
              <Col className='col-sm-2'>
                <label
                  className={`form-control-label ${required.address.country ? 'required' : ''}`}
                >
                  {t('country')}
                </label>
              </Col>
              <Col>
                <FormSelect
                  name={t('country')}
                  className='w-25 d-inline'
                  id={`address.${idx}.country`}
                  value={addr.country}
                  onChange={handleChangeLocal}
                  required={required.address.country}
                >
                  <option value=''>{'--'}</option>
                  {options.map((option: any) => (
                    <option key={option.value} value={option.value}>
                      {t(option.label)}
                    </option>
                  ))}
                </FormSelect>
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(`stammdaten.address.${idx}.country`, t('country'), options)
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </Col>
            </Row>

            {/* Versandzusatz */}
            <Row className='mt-4'>
              <Col className='col-sm-2'>
                <label
                  className={`form-control-label ${required.address.shipping_supplement ? 'required' : ''}`}
                >
                  {t('versandzusatz')}
                </label>
              </Col>
              <Col>
                <FormSelect
                  name={t('versandzusatz')}
                  className='w-25 d-inline'
                  id={`address.${idx}.shipping_supplement`}
                  value={addr.shipping_supplement}
                  required={required.address.shipping_supplement}
                  onChange={handleChangeLocal}
                >
                  <option value=''>{'--'}</option>

                  {shippingSuplement.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </FormSelect>
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(
                      `stammdaten.address.${idx}.shipping_supplement`,
                      t('versandzusatz'),
                      shippingSuplement
                    )
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </Col>
            </Row>

            {/* Abweichenden Zustelladressaten verwenden */}
            <Row className='mt-4'>
              <Col className='col-sm-2'>
                <label className='form-control-label'>{t('abweichenden')}</label>
              </Col>
              <Col className='col-sm-1'>
                <input
                  name={t('abweichenden')}
                  type='checkbox'
                  id={`address.${idx}.use_different_delivery_addressee`}
                  className='btn-spacing checkbox-large no-api'
                  checked={!!addr.use_different_delivery_addressee}
                  onChange={e => handleToggleDifferent(idx, e.target.checked)}
                />
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() =>
                    history(
                      `stammdaten.address.${idx}.use_different_delivery_addressee`,
                      t('abweichenden')
                    )
                  }
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </Col>
            </Row>

            {addr.use_different_delivery_addressee && (
              <>
                <Row className='mt-4'>
                  <Col className='col-sm-2'>
                    <label className='form-control-label'>{t('abwAnrede')}</label>
                  </Col>
                  <Col>
                    <FormSelect
                      name={t('abwAnrede')}
                      className='w-25 d-inline'
                      id={`address.${idx}.abbrev_salutation`}
                      value={addr.abbrev_salutation || ''}
                      onChange={handleChangeLocal}
                    >
                      <option value=''>--</option>
                      {abbrevSalutation.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                      {/* ... */}
                    </FormSelect>
                    <button
                      type='button'
                      className='btn btn-link btn-sm'
                      onClick={() =>
                        history(
                          `stammdaten.address.${idx}.abbrev_salutation`,
                          t('abwAnrede'),
                          abbrevSalutation
                        )
                      }
                    >
                      <i className='fa fa-history text-dark' aria-hidden='true'></i>
                    </button>
                  </Col>
                </Row>

                {/* Abweichender */}
                <Row className='mt-4'>
                  <Col className='col-sm-2'>
                    <label className='form-control-label'>{t('abweichender')}</label>
                  </Col>
                  <Col>
                    <FormControl
                      name={t('abweichender')}
                      className='w-25 d-inline'
                      type='text'
                      id={`address.${idx}.different_person`}
                      value={addr.different_person || ''}
                      onChange={handleChangeLocal}
                    />
                    <button
                      type='button'
                      className='btn btn-link btn-sm'
                      onClick={() =>
                        history(`stammdaten.address.${idx}.different_person`, t('abweichender'))
                      }
                    >
                      <i className='fa fa-history text-dark' aria-hidden='true'></i>
                    </button>
                  </Col>
                </Row>

                {/* Zustelladressat */}
                <Row className='mt-4'>
                  <Col className='col-sm-2'>
                    <label className='form-control-label'>{t('zustelladressat')}</label>
                  </Col>
                  <Col>
                    <FormControl
                      name={t('zustelladressat')}
                      className='w-25 d-inline'
                      type='text'
                      id={`address.${idx}.delivery_addressee`}
                      value={addr.delivery_addressee || ''}
                      onChange={handleChangeLocal}
                    />
                    <button
                      type='button'
                      className='btn btn-link btn-sm'
                      onClick={() =>
                        history(
                          `stammdaten.address.${idx}.delivery_addressee`,
                          t('zustelladressat')
                        )
                      }
                    >
                      <i className='fa fa-history text-dark' aria-hidden='true'></i>
                    </button>
                  </Col>
                </Row>
              </>
            )}

            {/* Notiz */}
            <Row className='mt-4'>
              <Col className='col-sm-2'>
                <label className={`form-control-label ${required.address.note ? 'required' : ''}`}>
                  {t('Notiz')}
                </label>
              </Col>
              <Col>
                <input
                  name={t('notice')}
                  className='w-50 d-inline form-control'
                  id={`address.${idx}.note`}
                  value={addr.note}
                  onChange={handleChangeLocal}
                  required={required.address.note}
                  maxLength={40}
                ></input>
                <button
                  type='button'
                  className='btn btn-link btn-sm'
                  onClick={() => history(`stammdaten.address.${idx}.note`, t('Notiz'))}
                >
                  <i className='fa fa-history text-dark' aria-hidden='true'></i>
                </button>
              </Col>
            </Row>
          </div>
        ))}

        <hr />
        <Row className='mt-3'>
          <Col>
            <Button
              variant='success'
              size='sm'
              className='btn btn-light p-0 d-flex align-items-center justify-content-center'
              style={{
                width: '28px',
                height: '28px',
                border: '1px solid #ced4da',
                color: '#198754', // bootstrap green
                fontWeight: 600,
                lineHeight: 1,
              }}
              onClick={handleAddAddress}
            >
              +
            </Button>
          </Col>
        </Row>
      </div>
    </>
  )
}
